import React from 'react';
import './TeamSection.css';

const people = [
  {
    name: 'Andrei Nintschew',
    role: 'Managing Partner',
    phone: '+43 1 288 07 44 – 11',
    mobile: '+43 664 515 0995',
    email: 'a.nintschew@nintschew-partner.at',
    photo: '/img/andrei_nintschew_steuerberatung.jpg',
  },
  {
    name: 'Maria Nintschewa',
    role: 'Office Management & Accounting',
    phone: '+43 1 288 07 44 – 13',
    mobile: '+43 664 515 0962',
    email: 'm.nintschewa@nintschew-partner.at',
    photo: '/img/maria_nintschewa_steuerberaterin.jpg',
  },
  {
    name: 'Bojana Joksic',
    role: 'Accounting',
    phone: '+43 1 288 07 44 – 14',
    mobile: '+43 664 436 8696',
    email: 'b.joksic@nintschew-partner.at',
    photo: '/img/bojana.jpg',
  },
  {
    name: 'Cornelia Rinner',
    role: 'Accounting',
    phone: '+43 1 288 07 44 – 18',
    mobile: null,
    email: 'c.rinner@nintschew-partner.at',
    photo: '/img/cornelia.jpg',
  },
  {
    name: 'Marlene Vidovitsch',
    role: 'Accounting (in Karenz)',
    phone: '+43 1 288 07 44',
    mobile: null,
    email: 'office@nintschew-partner.at',
    photo: '/img/marlene.jpg',
  },
];

const TeamSection = () => {
  const peopleWithPhoto = people.filter((p) => Boolean(p.photo));
  const peopleWithoutPhoto = people.filter((p) => !p.photo);

  return (
    <section className="team reveal" id="team">
      <div className="team__inner">
        <h3 className="team__title">Team</h3>
        <div className="team__grid">
          {peopleWithPhoto.map((p) => (
            <article key={p.name} className="team-card reveal">
              <img src={p.photo} alt={p.name} className="team-card__photo" />
              <div className="team-card__body">
                <h4 className="team-card__name">{p.name}</h4>
                <p className="team-card__role">{p.role}</p>
                <div className="team-card__contact">
                  <div>{p.phone}</div>
                  {p.mobile && <div>{p.mobile}</div>}
                  <a href={`mailto:${p.email}`} className="team-card__email">{p.email}</a>
                </div>
              </div>
            </article>
          ))}

          {peopleWithoutPhoto.length > 0 && (
            <article className="team-card team-card--stack reveal">
              {peopleWithoutPhoto.map((p, idx) => (
                <div key={p.name} className="team-card__stack-item">
                  <div className="team-card__stack-head">
                    <div className="team-card__avatar"><img src="/img/person.svg" alt="" /></div>
                    <div>
                      <h4 className="team-card__name">{p.name}</h4>
                      <p className="team-card__role">{p.role}</p>
                    </div>
                  </div>
                  <div className="team-card__contact">
                    <div>{p.phone}</div>
                    {p.mobile && <div>{p.mobile}</div>}
                    <a href={`mailto:${p.email}`} className="team-card__email">{p.email}</a>
                  </div>
                </div>
              ))}
            </article>
          )}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;


